var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { InputAdornment } from '@material-ui/core';
import { LoadingBounce, Select } from '@michelin/acid-components';
import React, { useEffect } from 'react';
import { Controller, useWatch, } from 'react-hook-form';
export function DependentFormControlledSelect(props) {
    var name = props.name, rules = props.rules, control = props.control, label = props.label, options = props.options, readOnly = props.readOnly, loading = props.loading, error = props.error, helperText = props.helperText, dependencies = props.dependencies, onDependenciesChanged = props.onDependenciesChanged;
    var watchedValue = useWatch({
        name: dependencies,
        control: control,
    });
    useEffect(function () {
        if (watchedValue) {
            // TODO: this should be typed more strictly
            var values_1 = {};
            var shouldTriggerDependenciesChanged_1 = true;
            dependencies.forEach(function (dep, idx) {
                if (watchedValue[idx] !== undefined) {
                    values_1[dep] = watchedValue[idx];
                }
                else {
                    shouldTriggerDependenciesChanged_1 = false;
                }
            });
            if (shouldTriggerDependenciesChanged_1) {
                onDependenciesChanged(values_1);
            }
        }
    }, [watchedValue]);
    return (React.createElement(Controller, { control: control, name: name, rules: rules, render: function (_a) {
            var field = _a.field;
            return (React.createElement(Select, __assign({ id: name, label: label, options: !options || loading ? [] : options, error: error, helperText: helperText, readOnly: readOnly || loading || !options || options.length === 0, required: !!(rules === null || rules === void 0 ? void 0 : rules.required), fullWidth: true }, field, { startAdornment: loading
                    ? (React.createElement(InputAdornment, { position: "start" },
                        React.createElement(LoadingBounce, { size: "8px" }))) : undefined })));
        } }));
}
//# sourceMappingURL=DependentFormControlledSelect.js.map